import { Dispatch, MouseEvent, ReactElement, SetStateAction } from 'react'
import { IconButton, InputAdornment, VisibilityIcon, VisibilityOffIcon } from '@internations/ds'

type PasswordVisibilityAdornmentProps = {
    showPassword: boolean
    setShowPassword: Dispatch<SetStateAction<boolean>>
}

export const PasswordVisibilityAdornment = ({
    showPassword,
    setShowPassword,
}: PasswordVisibilityAdornmentProps): ReactElement => {
    const mouseHandler = (event: MouseEvent) => event.preventDefault()

    return (
        <InputAdornment position="end">
            <IconButton
                aria-label={showPassword ? 'hide the password' : 'display the password'}
                onClick={() => setShowPassword((show) => !show)}
                onMouseDown={mouseHandler}
                onMouseUp={mouseHandler}
                edge="end"
                Icon={showPassword ? VisibilityOffIcon : VisibilityIcon}
            />
        </InputAdornment>
    )
}
